@if (source() === 'ai' && !reviewed()) {
  <span class="source-badge ai" matTooltip="Detected by AI" aria-label="Detected by AI">
    <mat-icon>auto_awesome</mat-icon>
  </span>
}
